// const baseURL = "http://34.123.221.86";
const baseURL = process.env.REACT_APP_API_URL;
export default baseURL;